import { IExportRecordDetail, IExportRecordSearch } from './exportRecordTypes'
import { httpRequest } from '@/utils/HttpRequest'
import  {CLIENT_APP_CODE, getBaseRequestUrl1} from  '@/utils/constants'
import { IPage } from '@/types/FmsTypes'
class ExportRecordService {
    async page(params: IExportRecordSearch) {
        params.searchItem = {
            ...params.searchItem,
            // 默认参数
            appName: CLIENT_APP_CODE,
        }
        const apiUrl = '/yh-export/export/record/list'
        return await httpRequest.post<IPage<IExportRecordDetail>>(apiUrl, params,{baseURL: getBaseRequestUrl1()})
    }
}
export const exportRecordService = new ExportRecordService()
